import { reviews } from "@/mocks/reviews";

const GMB_URL = "https://maps.app.goo.gl/kadTYV8afmpfdVSu8";

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#FFB100] text-sm"></i>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  return (
    <section id="avis" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#FFB100]/10 text-[#FFB100] text-xs font-black px-3 py-1.5 rounded-full mb-4 uppercase tracking-widest">
              <i className="ri-google-line"></i>
              Avis Google
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-black uppercase leading-tight mb-3">
              Ils Nous Font Confiance
            </h2>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFB100] text-xl"></i>
                ))}
              </div>
              <span className="font-black text-2xl text-black">4.9</span>
              <span className="text-gray-400 text-sm">/5 sur Google</span>
            </div>
          </div>
          <a
            href={GMB_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 border-2 border-black text-black font-bold text-sm px-5 py-3 rounded-full hover:bg-black hover:text-white transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            <i className="ri-external-link-line"></i>
            Voir tous les avis Google
          </a>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white border border-gray-100 rounded-2xl p-6 hover:border-[#FFB100]/30 hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full font-black text-base flex-shrink-0 ${review.color}`}
                >
                  {review.initial}
                </div>
                <div>
                  <p className="font-bold text-black text-sm">{review.name}</p>
                  <p className="text-gray-400 text-xs">{review.date}</p>
                </div>
                <div className="ml-auto">
                  <i className="ri-google-line text-gray-300 text-lg"></i>
                </div>
              </div>
              <StarRating count={review.stars} />
              <p className="text-gray-600 text-sm leading-relaxed mt-3">
                &ldquo;{review.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
